import { render } from "@/share/components/pages/projectData/ProjectData.html?vue&type=template&id=a90b0a1e&scoped=true&external"
import script from "@/share/components/pages/projectData/ProjectData.js?vue&type=script&lang=js&external"
export * from "@/share/components/pages/projectData/ProjectData.js?vue&type=script&lang=js&external"

import "@/share/components/pages/projectData/ProjectData.scss?vue&type=style&index=0&id=a90b0a1e&lang=scss&scoped=true&external"

import exportComponent from "../../../../execute/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90b0a1e"]])

export default __exports__